export function sanitizeHtml(input: string | undefined | null): string {
  const htmlString = input || ''
  return htmlString.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
}
